import { ErrorMessage, formData, responseData, setErrorReceived, getErrorMessage } from '../../utils/data';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PrintPage from '../PrintPage';
import Loading from '../Loading';
import { useAuth } from '../../context/AuthContext';
import { createLog } from '../datawriter/createLog';
import "../print.css"

function VehicleResponse() {
    const [testData, setTestData] = useState({});
    const [loading, setLoading] = useState(true);
    const [requestID, setRequestID ]= useState();
    const [errorMessage, setErrorMessage] = useState([]);
    const navigate = useNavigate();
    const { token, email } = useAuth();

    useEffect(() => {
        //createLog("", email);
        const fetchData = async () => {
          try {
            await responseData('/api/vehicle', token)
            .then(function (response) {
                createLog(response, email);
                if(response.Response?.VehicleDetails !== undefined) {
                    setErrorMessage(response.Messages);
                    setTestData(response);
                    console.log("Completed:",response);
                    setRequestID(response.TransactionGUID);
                    setLoading(false);
                } else {
                    setErrorReceived(response.Messages.length > 0 ? response.Messages : ["Database Unavailable"]);
                    navigate(-1);
                }
            })
            .catch(  (error) => {
                console.error(error);
                setErrorReceived([getErrorMessage(error, 'Unable to retrieve vehicle information. Please try again.')]);
                navigate(-1);
            })
            
          } catch (error) {
            console.error('caught error: ', error);
            setErrorReceived([getErrorMessage(error, 'Unable to retrieve vehicle information. Please try again.')]);
            navigate(-1);
          }
          
        };
    
        fetchData();
    }, []);
    
    if(loading){
        return(<>
            <Loading />
            </>)
        }
    return(
        <>
        <div id='print-area'>
            {errorMessage.map((message => (
                <ErrorMessage value={message} />
            )))}
            <div id='table' style={{minWidth:'85%'}}>
                
            <div style={{ fontSize:'medium', background: 'white'}}>
                <div id="banner-results">
                <h4>Vehicle Search Results</h4>
                <h6>
                    {formData.Body.VehicleRequest.PLATE &&
                    <span>/{formData.Body.VehicleRequest.PLATE}</span>
                    }
                    {formData.Body.VehicleRequest.VIN &&
                    <span>/{formData.Body.VehicleRequest.VIN}</span>
                    }
                    {formData.Body.VehicleRequest.RFC &&
                    <span>/{formData.Body.VehicleRequest.RFC}</span>
                    }
                    <span style={{float: 'right' }}>{requestID}</span>
                </h6>
                </div>
                {formData.Body.VehicleRequest.RFC === '' ? 
                <><h3>Plate</h3>
                
                <table className="table table-striped table-bordered">
                
                <thead style={{width: '100%'}}>
                    <tr>
                        <th scope="col">Plate ID: </th>
                        <td>{testData.Response.VehicleDetails?.VehiclePlateDetails?.PlateId}</td>
                    </tr>
                    <tr>
                        <th scope="col">Status: </th>
                        <td>{testData.Response.VehicleDetails?.VehiclePlateDetails?.Status}</td>
                    </tr>
                    <tr>
                        <th scope="col">Type of Service: </th>
                        <td>{testData.Response.VehicleDetails?.VehiclePlateDetails?.TypeOfService}</td>
                    </tr>
                </thead>
                <h3>Vehicle</h3>
                <thead style={{ width: '100%' }}>
                    <tr>
                        <th scope="col">Vehicle ID: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.VehicleId}</td>
                    </tr>
                    <tr>
                        <th scope="col">Engine ID: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.EngineId}</td>
                    </tr>
                    <tr>
                        <th scope="col">Country Manufactured: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.CountryManufactured}</td>
                    </tr>
                    <tr>
                        <th scope="col">Type of Service: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.TypeOfService}</td>
                    </tr>
                    <tr>
                        <th scope="col">Class: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.Class}</td>
                    </tr>
                    <tr>
                        <th scope="col">Make: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.Make}</td>
                    </tr>
                    <tr>
                        <th scope="col">Year: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.Year}</td>
                    </tr>
                    <tr>
                        <th scope="col">Years Vehicle Can Operate: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.YearsVehicleCanOperate}</td>
                    </tr>
                    <tr>
                        <th scope="col">Suspension: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.Suspension}</td>
                    </tr>
                    <tr>
                        <th scope="col">Steering Suspension: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.SteeringSuspension}</td>
                    </tr>
                    <tr>
                        <th scope="col">Trailing Suspension: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.TrailingSuspension}</td>
                    </tr>
                    <tr>
                        <th scope="col">Capacity: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.Capacity}</td>
                    </tr>
                    <tr>
                        <th scope="col">Capacity in Units: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.CapacityInUnits}</td>
                    </tr>
                    <tr>
                        <th scope="col">Number of Tires: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.NumberOfTires}</td>
                    </tr>
                    <tr>
                        <th scope="col">Number of Axles: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.NumberOfAxles}</td>
                    </tr>
                    <tr>
                        <th scope="col">Height(Meters): </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.Height}</td>
                    </tr>
                    <tr>
                        <th scope="col">Length(Meters): </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.Length}</td>
                    </tr>
                    <tr>
                        <th scope="col">Weight(Tons): </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.Weight}</td>
                    </tr>
                    <tr>
                        <th scope="col">Gross Weight(Tons): </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.GrossWeight}</td>
                    </tr>
                    <tr>
                        <th scope="col">Width(Meters): </th>
                        <td>{testData.Response.VehicleDetails?.VehicleIdentificationDetails?.Width}</td>
                    </tr>
                </thead>
                <h3>Carrier</h3>
                <thead style={{ width: '100%' }}>
                    <tr>
                        <th scope="col">RFC: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleCarrierDetails?.RFC}</td>
                    </tr>
                    <tr>
                        <th scope="col">CURP: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleCarrierDetails?.CURP}</td>
                    </tr>
                    <tr>
                        <th scope="col">US DOT Number: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleCarrierDetails?.USDOTNumber}</td>
                    </tr>
                    <tr>
                        <th scope="col">Name: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleCarrierDetails?.Name}</td>
                    </tr>
                    <tr>
                        <th scope="col">Type of Carrier Service: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleCarrierDetails?.TypeOfCarrierService}</td>
                    </tr>
                    <tr>
                        <th scope="col">Federal Service: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleCarrierDetails?.FederalService}</td>
                    </tr>
                    <tr>
                        <th scope="col">Private Service: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleCarrierDetails?.PrivateService}</td>
                    </tr>
                    <tr>
                        <th scope="col">Street Address: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleCarrierDetails?.StreetAddress}</td>
                    </tr>
                    <tr>
                        <th scope="col">Neighborhood(Colonia): </th>
                        <td>{testData.Response.VehicleDetails?.VehicleCarrierDetails?.Neighborhood}</td>
                    </tr>
                    <tr>
                        <th scope="col">City/County: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleCarrierDetails?.CityOrCounty}</td>
                    </tr>
                    <tr>
                        <th scope="col">State: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleCarrierDetails?.State}</td>
                    </tr>
                    <tr>
                        <th scope="col">Postal Code: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleCarrierDetails?.PostalCode}</td>
                    </tr>
                    <tr>
                        <th scope="col">Phone Number: </th>
                        <td>{testData.Response.VehicleDetails?.VehicleCarrierDetails?.PhoneNumber}</td>
                    </tr>
                    </thead>
                </table></> : 
                <><h3>RFC: {testData.Response.VehicleDetails?.RFC}</h3>
                <table className="table table-striped table-bordered">
                <thead style={{ width: '100%' }}>
                    <tr>
                        <th scope="col">RFC: </th>
                        <td>{testData.Response.VehicleDetails?.RFC}</td>
                    </tr>
                    <tr>
                        <th scope="col">CURP: </th>
                        <td>{testData.Response.VehicleDetails?.CURP}</td>
                    </tr>
                    <tr>
                        <th scope="col">US DOT Number: </th>
                        <td>{testData.Response.VehicleDetails?.USDOTNumber}</td>
                    </tr>
                    <tr>
                        <th scope="col">Name: </th>
                        <td>{testData.Response.VehicleDetails?.Name}</td>
                    </tr>
                    <tr>
                        <th scope="col">Motor Carrier Status: </th>
                        <td>{testData.Response.VehicleDetails?.MotorCarrierStatus}</td>
                    </tr>
                    <tr>
                        <th scope="col">Authorization Date </th>
                        <td>{testData.Response.VehicleDetails?.AuthorizationDate}</td>
                    </tr>
                    <tr>
                        <th scope="col">Street Address: </th>
                        <td>{testData.Response.VehicleDetails?.StreetAddress}</td>
                    </tr>
                    <tr>
                        <th scope="col">Neighborhood(Colonia): </th>
                        <td>{testData.Response.VehicleDetails?.Neighborhood}</td>
                    </tr>
                    <tr>
                        <th scope="col">City/County: </th>
                        <td>{testData.Response.VehicleDetails?.CityOrCounty}</td>
                    </tr>
                    <tr>
                        <th scope="col">State: </th>
                        <td>{testData.Response.VehicleDetails?.State}</td>
                    </tr>
                    <tr>
                        <th scope="col">Postal Code: </th>
                        <td>{testData.Response.VehicleDetails?.PostalCode}</td>
                    </tr>
                    <tr>
                        <th scope="col">Phone Number: </th>
                        <td>{testData.Response.VehicleDetails?.PhoneNumber}</td>
                    </tr>
                </thead>
                </table></> 
                }
                </div>
            </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
            <a href='/'><button type="button" class="btn btn-primary" id="button">Done</button></a>
            <PrintPage
            type="vehicle"
            response={testData.Response}
            queryLine={
                formData.Body.VehicleRequest?.VIN
                ? `/${formData.Body.VehicleRequest.VIN}`
                : formData.Body.VehicleRequest?.PLATE
                ? `/${formData.Body.VehicleRequest.PLATE}`
                : `/${formData.Body.VehicleRequest?.RFC || ''}`
            }
            transactionID={requestID}
            messages={errorMessage}
            />

         </div>
         </div></>
    );
}
export default VehicleResponse;